import { Stack, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import React, { SyntheticEvent, useCallback, useMemo, useState } from 'react'
import { EOp, FilterModelText, Nullish, TraineeStatus, TraineeStatusOptions } from 'types'

type StatusOption = Nullish<{ value: TraineeStatus; label: string }>

export function useTraineeStatusFilter() {
  const [statusValue, setStatusValue] = useState<StatusOption>(null)

  const traineeStatusFilterValue: Nullish<FilterModelText> = useMemo(() => {
    if (statusValue) {
      return {
        type: 'text',
        op: EOp.equals,
        value: statusValue.value.toLowerCase(),
      } as FilterModelText
    }

    return null
  }, [statusValue])

  const handleChange = useCallback((_: SyntheticEvent, newValue: StatusOption) => {
    setStatusValue(newValue)
  }, [])

  const TraineeStatusFilter = useMemo(() => {
    return (
      <Stack direction="row" alignItems="center" className="gap-8">
        <Typography>Status</Typography>

        <Autocomplete
          multiple={false}
          options={TraineeStatusOptions}
          value={statusValue}
          onChange={handleChange}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              name="status"
              InputProps={{
                ...params.InputProps,
                endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
              }}
            />
          )}
        />
      </Stack>
    )
  }, [handleChange, statusValue])

  return { TraineeStatusFilter, traineeStatusFilterValue }
}
